import React from "react";

 const socialContent = [
  {
    icon: "fa-facebook",
    link: "https://www.facebook.com/profile.php?id=61561217462079",
  },
  {
    icon: "fa-instagram",
    link: "https://www.instagram.com/clientctrl/",
  },
  {
    icon: "fa-linkedin",
    link: "https://www.linkedin.com/company/sash-info-services-pvt-ltd",
  },
  {
    icon: "fa-whatsapp",
    link: "https://wa.me/+919242137092?text=Hello!",
  },
];

const ContactAddress = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-lg-4 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/44.svg" alt="icon" />
          </div>
          <div className="title">Location</div>
          <p className="font-rubik">
            Bangalore, <br /> India
          </p>
        </div>{" "}
        {/* /.address-info  */}
      </div>
      {/* End .col */}

      <div className="col-lg-4 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/45.svg" alt="icon" />
          </div>
          <div className="title">Contact</div>
          <p className="font-rubik">
          <a href="mailto:sales@clientctrl.app">sales@clientctrl.app</a> <br />
            <a href="tel:+919242137092">(+91) 924-213-7092</a>
          </p>
        </div>{" "}
        {/* /.address-info  */}
      </div>
      {/* End .col */}

      <div className="col-lg-4 col-sm-6 d-lg-flex">
        <div className="address-info">
          <div className="icon d-flex align-items-end">
            <img src="images/icon/46.svg" alt="icon" />
          </div>
          <div className="title">Social Media</div>
          <p className="font-rubik">Find on social media</p>
          <ul className="d-flex justify-content-center">
            {socialContent.map((val, i) => (
              <li key={i}>
                <a href={val.link} target="_blank" rel="noreferrer">
                  <i className={`fa ${val.icon}`}></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
        {/* /.address-info  */}
      </div>
      {/* End .col */}
    </div>
  );
};

export default ContactAddress;
